import { success } from "@secretaa/http-contract";
import { z } from "zod";
import { Scope,Profile } from "./ai-model-control.ts";
import { PreparationDraftOutput } from "./work-os/instructions.ts";
import { PreparationDraftArtifact } from "./work-os/preparation-artifact.ts";
export const Command=z.object({scope:Scope,profile:Profile,expectedRunRevision:z.number().int().positive(),...PreparationDraftOutput.shape}).strict();
export type Command=z.infer<typeof Command>;
export const Result=z.object({scope:Scope,profile:Profile,runRevision:z.number().int().positive(),state:z.literal("SUCCEEDED"),output:PreparationDraftOutput,artifact:PreparationDraftArtifact}).strict().superRefine((r,ctx)=>{
 if(r.artifact.artifact.aiRunId!==r.scope.aiRunId || r.artifact.artifact.scope.workspaceId!==r.scope.workspaceId || JSON.stringify(r.output.draft)!==JSON.stringify(r.artifact.content))ctx.addIssue({code:"custom",message:"CHILD_OUTPUT_BINDING_INVALID"});
}).refine(r=>new TextEncoder().encode(JSON.stringify(r)).byteLength<=63000,"CHILD_RESULT_TOO_LARGE");
export type Result=z.infer<typeof Result>;
export const Response=success(Result);
export const PATH="/api/internal/v1/ai-preparation-child-replies";
export const CONTRACT_VERSION="1.0.0";
